export const translations = {
  en: {
    nav: {
      strategy: "Strategy",
      contentCreation: "Content Creation",
      campaigns: "Campaigns",
      webAutomation: "Web Automation",
      contacts: "Contacts",
    },
    hero: {
      weConnect: "we connect",
      words: ["Strategy", "Identity", "Creativity", "Growth", "Dynamism", "Community"],
      headline: "ViDi. Communicate your identity.",
      tagline1: "Communicate your ",
      tagline2: "identity",
    },
    about: {
      tagline: "Because a brand can grow, perform, and stay true to itself at the same time.",
      strategy: {
        title: "Strategy",
        text: "We define a clear direction for the brand, so every decision, message, and move has purpose, consistency, and room to grow.",
      },
      contentCreation: {
        title: "Content Creation",
        text: "We turn the brand's identity into content that feels coherent, recognisable, and worth paying attention to.",
      },
      campaigns: {
        title: "Campaigns",
        text: "We create campaigns that are built to perform while still sounding, looking, and feeling true to the brand.",
      },
      webAutomation: {
        title: "Web Automation",
        text: "We design smarter digital systems that simplify processes, improve flow, and make the brand work better without losing its human side.",
      },
    },
    sections: {
      strategy: {
        title: "STRATEGY",
        text: "We define the direction before the brand starts moving. That means analysing context, positioning, identity, audience, competitors, and opportunities, then turning all of it into a clearer point of view and a more solid decision-making framework.",
      },
      contentCreation: {
        title: "CONTENT CREATION",
        text: "We turn the brand into something people can actually see, hear, and recognise. From art direction and copy to visual assets, social formats, and editorial systems, the goal is to create content that feels coherent, distinctive, and consistently on-brand.",
      },
      campaigns: {
        title: "CAMPAIGNS",
        text: "We build campaigns with a clear objective and a clear voice. That includes concept development, messaging, creative direction, launch planning, and performance thinking, so the brand can reach people effectively.",
      },
      webAutomation: {
        title: "WEB AUTOMATION",
        text: "We design digital systems that make the brand easier to run. From automated flows and lead handling to website logic, customer journeys, and connected tools, the focus is on reducing friction, saving time, and improving how everything works behind the scenes.",
      },
    },
    clients: { title: "ViDi has seen…" },
    contact: {
      title: "Make it ViDi",
      name: "Name",
      phone: "Phone",
      email: "Email",
      message: "Message",
      send: "Send",
      sending: "Sending…",
      consent: "I have read and agree to the",
      consentLink: "Privacy Policy",
      success: "Message sent successfully!",
      error: "Error sending message. Please try again.",
    },
    footer: { tagline: "Communicate your identity." },
  },
  it: {
    nav: {
      strategy: "Strategia",
      contentCreation: "Creazione Contenuti",
      campaigns: "Campagne",
      webAutomation: "Web Automation",
      contacts: "Contatti",
    },
    hero: {
      weConnect: "connettiamo",
      words: ["Strategia", "Identità", "Creatività", "Crescita", "Dinamismo", "Community"],
      headline: "ViDi. Comunica la tua identità.",
      tagline1: "Comunica la tua ",
      tagline2: "identità",
    },
    about: {
      tagline: "Perché un brand può crescere, performare e rimanere fedele a sé stesso allo stesso tempo.",
      strategy: {
        title: "Strategia",
        text: "Definiamo una direzione chiara per il brand, affinché ogni decisione, messaggio e azione abbia scopo, coerenza e spazio per crescere.",
      },
      contentCreation: {
        title: "Creazione Contenuti",
        text: "Trasformiamo l'identità del brand in contenuti coerenti, riconoscibili e degni di attenzione.",
      },
      campaigns: {
        title: "Campagne",
        text: "Creiamo campagne progettate per performare, mantenendo al contempo l'autenticità del brand.",
      },
      webAutomation: {
        title: "Web Automation",
        text: "Progettiamo sistemi digitali intelligenti che semplificano i processi e fanno funzionare meglio il brand senza perdere il lato umano.",
      },
    },
    sections: {
      strategy: {
        title: "STRATEGIA",
        text: "Definiamo la direzione prima che il brand inizi a muoversi. Questo significa analizzare contesto, posizionamento, identità, pubblico, concorrenti e opportunità, trasformando tutto in un punto di vista più chiaro e un framework decisionale più solido.",
      },
      contentCreation: {
        title: "CREAZIONE CONTENUTI",
        text: "Trasformiamo il brand in qualcosa che le persone possono effettivamente vedere, sentire e riconoscere. Dalla direzione artistica e copy agli asset visivi, formati social e sistemi editoriali, l'obiettivo è creare contenuti coerenti, distintivi e costantemente in linea con il brand.",
      },
      campaigns: {
        title: "CAMPAGNE",
        text: "Costruiamo campagne con un obiettivo chiaro e una voce definita. Questo include sviluppo del concept, messaggistica, direzione creativa, pianificazione del lancio e pensiero orientato alla performance, affinché il brand raggiunga le persone in modo efficace.",
      },
      webAutomation: {
        title: "WEB AUTOMATION",
        text: "Progettiamo sistemi digitali che rendono il brand più facile da gestire. Dai flussi automatizzati alla gestione dei lead, dalla logica del sito ai percorsi dei clienti e agli strumenti connessi, il focus è ridurre l'attrito, risparmiare tempo e migliorare il funzionamento complessivo.",
      },
    },
    clients: { title: "ViDi ha visto…" },
    contact: {
      title: "Make it ViDi",
      name: "Nome",
      phone: "Telefono",
      email: "Email",
      message: "Messaggio",
      consent: "Ho letto e accetto la",
      consentLink: "Privacy Policy",
      send: "Invia",
      sending: "Invio…",
      success: "Messaggio inviato con successo!",
      error: "Errore nell'invio. Riprova.",
    },
    footer: { tagline: "Comunica la tua identità." },
  },
  es: {
    nav: {
      strategy: "Estrategia",
      contentCreation: "Creación de Contenido",
      campaigns: "Campañas",
      webAutomation: "Automatización Web",
      contacts: "Contacto",
    },
    hero: {
      weConnect: "conectamos",
      words: ["Estrategia", "Identidad", "Creatividad", "Crecimiento", "Dinamismo", "Comunidad"],
      headline: "ViDi. Comunica tu identidad.",
      tagline1: "Comunica tu ",
      tagline2: "identidad",
    },
    about: {
      tagline: "Porque una marca puede crecer, rendir y mantenerse fiel a sí misma al mismo tiempo.",
      strategy: {
        title: "Estrategia",
        text: "Definimos una dirección clara para la marca, para que cada decisión, mensaje y movimiento tenga propósito, coherencia y espacio para crecer.",
      },
      contentCreation: {
        title: "Creación de Contenido",
        text: "Convertimos la identidad de la marca en contenido coherente, reconocible y que merece atención.",
      },
      campaigns: {
        title: "Campañas",
        text: "Creamos campañas diseñadas para rendir, manteniéndose fieles al sonido, la apariencia y la sensación auténtica de la marca.",
      },
      webAutomation: {
        title: "Automatización Web",
        text: "Diseñamos sistemas digitales inteligentes que simplifican procesos y hacen que la marca funcione mejor sin perder su lado humano.",
      },
    },
    sections: {
      strategy: {
        title: "ESTRATEGIA",
        text: "Definimos la dirección antes de que la marca empiece a moverse. Eso significa analizar contexto, posicionamiento, identidad, audiencia, competidores y oportunidades, para convertir todo en un punto de vista más claro y un marco de toma de decisiones más sólido.",
      },
      contentCreation: {
        title: "CREACIÓN DE CONTENIDO",
        text: "Convertimos la marca en algo que la gente puede ver, escuchar y reconocer. Desde la dirección artística y el copy hasta los activos visuales, formatos sociales y sistemas editoriales, el objetivo es crear contenido coherente, distintivo y alineado con la marca.",
      },
      campaigns: {
        title: "CAMPAÑAS",
        text: "Construimos campañas con un objetivo claro y una voz definida. Esto incluye el desarrollo del concepto, la mensajería, la dirección creativa, la planificación del lanzamiento y el pensamiento orientado al rendimiento.",
      },
      webAutomation: {
        title: "AUTOMATIZACIÓN WEB",
        text: "Diseñamos sistemas digitales que facilitan la gestión de la marca. Desde flujos automatizados y gestión de leads hasta la lógica del sitio web, los recorridos de los clientes y las herramientas conectadas.",
      },
    },
    clients: { title: "ViDi ha visto…" },
    contact: {
      title: "Make it ViDi",
      name: "Nombre",
      phone: "Teléfono",
      email: "Email",
      message: "Mensaje",
      send: "Enviar",
      sending: "Enviando…",
      consent: "He leído y acepto la",
      consentLink: "Política de Privacidad",
      success: "¡Mensaje enviado con éxito!",
      error: "Error al enviar el mensaje. Inténtalo de nuevo.",
    },
    footer: { tagline: "Comunica tu identidad." },
  },
};
